import '../../base/buttons/as-icon-button';
import styleText from './as-session-set.css?raw';

/**
 * Session management section component
 */
export class TrSessionSet extends HTMLElement {
  private static readonly sheet = (() => {
    const sheet = new CSSStyleSheet();
    sheet.replaceSync(styleText);
    return sheet;
  })();
  private configurator?: any;

  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.shadowRoot!.adoptedStyleSheets = [
      ...this.shadowRoot!.adoptedStyleSheets,
      TrSessionSet.sheet
    ];
    
    this.shadowRoot!.innerHTML = /*html*/`
      <div id="header-session-set">
        <as-icon-button 
          file-name="header/file-new.png" black
          tooltip-dict-key="tooltip.session.new"
          tooltip-default-text="New session"
          name="new"
        ></as-icon-button>
        <as-icon-button 
          file-name="header/restore.png" black
          tooltip-dict-key="tooltip.session.restore"
          tooltip-default-text="Restore session"
          name="restore"
        ></as-icon-button>
        <as-icon-button 
          file-name="header/save.png" black
          tooltip-dict-key="tooltip.session.save"
          tooltip-default-text="Save session"
          name="save"
        ></as-icon-button>
      </div>
      <input type="file" accept=".zip" id="backup-restore">
    `;

    this.setupEventListeners();
  }

  private setupEventListeners(): void {
    const container = this.shadowRoot!.querySelector('#header-session-set');
    if (!container) return;

    // Add event listeners to buttons
    const newButton = container.querySelector('as-icon-button[name="new"]') as HTMLElement;
    const restoreButton = container.querySelector('as-icon-button[name="restore"]') as HTMLElement;
    const saveButton = container.querySelector('as-icon-button[name="save"]') as HTMLElement;

    newButton?.addEventListener('as-button-click', (e: CustomEvent) => {
      this.dispatchEvent(new CustomEvent('new-session', {
        bubbles: true,
        composed: true
      }));
    });

    restoreButton?.addEventListener('as-button-click', (e: CustomEvent) => {
      this.dispatchEvent(new CustomEvent('restore-session', {
        bubbles: true,
        composed: true
      }));
    });

    saveButton?.addEventListener('as-button-click', (e: CustomEvent) => {
      this.dispatchEvent(new CustomEvent('save-session', {
        bubbles: true,
        composed: true
      }));
    });
  }

  // private handleRestore(): void {
  //   const input = document.createElement('input');
  //   input.type = 'file';
  //   input.id = 'restoreFileInput';
  //   input.style.display = 'none';
  //   input.onchange = () => {
  //     this.dispatchEvent(new CustomEvent('restore-complete', {
  //       bubbles: true,
  //       composed: true
  //     }));
  //   };
  //   document.getElementById('step-bar')?.appendChild(input);
  //   input.click();
  // }

  // private handleSave(): void {
  //   this.configurator?.saveSession?.((res: any) => {
  //     const blob = new Blob([res], { type: 'application/zip' });
  //     const link = document.createElement('a');
  //     link.href = window.URL.createObjectURL(blob);
  //     link.download = 'configuration.zip';
  //     document.body.appendChild(link);
  //     link.click();
  //     document.body.removeChild(link);
  //   });
  // }

  connectedCallback() {
    // Listen for configurator creation
    document.addEventListener('as-cfgr-comp-ready', (event: CustomEvent) => {
      this.configurator = event.detail?.configurator;
    });

    // // Handle session events
    // this.addEventListener('new-session', () => {
    //   // Optional: Implement new session handler if needed
    //   console.log('New session requested');
    // });

    // this.addEventListener('restore-session', () => {
    //   this.handleRestore();
    // });

    // this.addEventListener('save-session', () => {
    //   this.handleSave();
    // });
  }
}

customElements.define('as-session-set', TrSessionSet); 
